import { Box, Form, FormContext, Flex } from "dash-ui"
import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { DashValidation } from 'dash-common';

import { useValidation } from "pages/ProfilePage/components/AccountInfo/components/AccountInfoForm/AccountInfoForm.hooks";
import { useTranslation } from "react-i18next";

import { FormFields } from "pages/ProfilePage/components/AccountInfo/components/AccountInfoForm/AccountInfoForm.constants";


const BrokerDescriptionInfo = () => {
  const { t } = useTranslation("forms");
  const theme = useTheme();
  
  const { formState, stateHandlers, formErrors } = useContext(FormContext);
    const validateFieldByName = useValidation();
  
  const handleDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    stateHandlers[FormFields.ShortDescription](value);
    validateFieldByName(FormFields.ShortDescription, value);
  };

  return (
    <Box mb={4} w="100%">
    
    <Form.Group mb={4}>
      <Flex w="100%" justifyContent="space-between">
        <Flex flexGrow={1}>
          <Form.Label>{t('forms:labels.shortDescription')}</Form.Label>
        </Flex>
        <Flex>
          <Form.Label color={theme.colors.n70}>
            {formState.shortDescription?.length || 0}/
            {DashValidation.MaxDescriptionLength}
          </Form.Label>
        </Flex>
      </Flex>
      <Form.Textarea
        value={formState.shortDescription || ''}
        placeholder={t('forms:placeholders.enterDescription') || ''}
        onChange={handleDescription}
        $errorType={formErrors[FormFields.ShortDescription]?.type}
        minHeight={150}
      />
      <Form.Feedback
        $errorType={formErrors[FormFields.ShortDescription]?.type}
      >
        {formErrors[FormFields.ShortDescription]?.message}
      </Form.Feedback>
    </Form.Group>
  </Box>
  )
}

export default BrokerDescriptionInfo